import { Button, Grid, Typography } from '@mui/material';
import { useQuery } from '@apollo/client';
import { getProcureVendorsWithFilters, ProcureVendor } from 'vendor-marketplace-shared-library';
import useAlert from '../../hooks/useAlert';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

const columnWidth = (window.innerWidth * 0.75) / 6;

const columns: GridColDef[] = [
  { field: 'name', headerName: 'Name', width: columnWidth },
  { field: 'phone', headerName: 'Phone', width: columnWidth },
  { field: 'email', headerName: 'Email', width: columnWidth },
  { field: 'issueTypes', headerName: 'Issue Types', width: columnWidth },
  { field: 'vendorContact', headerName: 'Vendor Contact', width: columnWidth },
  { field: 'properties', headerName: 'Properties', width: columnWidth },
];

export default function ProcureVendorsPage() {
  const alert = useAlert();
  const navigate = useNavigate();

  const { data: vendorData } = useQuery(getProcureVendorsWithFilters, {
    onError: () => {
      alert.setAlert({ severity: 'error', message: 'Error loading vendors.' });
    },
  });

  const vendors = vendorData?.getProcureVendorsWithFilters || [];

  const rows = useMemo(() => {
    return vendors.map((vendor: ProcureVendor) => ({
      ...vendor,
      id: vendor.id,
      name: vendor.name,
      properties: vendor.properties?.map(property => property.name).join(', '),
      issueTypes: vendor.issueTypes?.map(issueType => issueType.name).join(', ') || '—',
      vendorContact:
        vendor.procureVendorContacts?.map(contact => contact.fullName).join(', ') || '—',
    }));
  }, [vendors]);

  const onRowClickNavigation = (id: string) => {
    navigate(`/vendors/${id}`);
  };

  return (
    <Grid container spacing={4}>
      <Grid item container sx={{ justifyContent: 'space-between' }}>
        <Grid item>
          <Typography variant={'h6'}>Vendors</Typography>
        </Grid>
        <Grid item>
          <Button onClick={() => navigate('/vendors/create')}>Add a vendor</Button>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <DataGrid
          sx={styles.dataGrid}
          rows={rows}
          columns={columns}
          onRowClick={row => onRowClickNavigation(row.row.id)}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 10,
                page: 0,
              },
            },
            sorting: {
              sortModel: [{ field: 'name', sort: 'asc' }],
            },
          }}
          pageSizeOptions={[5, 10]}
        />
      </Grid>
    </Grid>
  );
}

const styles = {
  dataGrid: {
    minHeight: 150,
    '& .MuiDataGrid-cell:focus': {
      outline: ' none',
    },
    '& .MuiDataGrid-row:hover': {
      cursor: 'pointer',
    },
  },
};
